import script from "./ListarRegistrosFinanceiros.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarRegistrosFinanceiros.vue?vue&type=script&setup=true&lang=js"

import "./ListarRegistrosFinanceiros.vue?vue&type=style&index=0&id=cbd8a616&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbd8a616"]])

export default __exports__